import { Response } from "@version2/domain-package";

const s400 = {
  USER__NOT_FOUND: new Response({
    status: 400,
    code: "user/not-found",
    message: "user not found",
  }),
  GENERAL__MISSING_ARGUMENTS: new Response({
    status: 422,
    code: "general/missing-arguments",
  }),
  GENERAL__INVALID_ARGUMENTS: new Response({
    status: 422,
    code: "general/invalid-arguments",
  }),
  GENERAL__BAD_REQUEST: new Response({
    status: 400,
    code: "general/bad-request",
  }),
  USER__NOT_AUTHORIZED: new Response({
    status: 403,
    code: "user/not-authorized",
    message: "user not authorized",
  }),
  USER__NOT_AUTHORIZED_FOR_ROLE: new Response({
    status: 403,
    code: "user/not-authorized-for-role",
    message: "user not authorized for role",
  }),
};

export default s400;
